import { Component, OnInit } from '@angular/core';
import { WorkflowActionHistoryComponent } from '@dsvs/workflow-generator-ui-lib';
import { MessageService } from 'primeng/components/common/messageservice';
import { FileServiceImpl } from '../../../../../shared/services/file.service';

@Component({
  selector: 'fes-fes-workflow-action-note-add-history',
  templateUrl: './fes-workflow-action-note-add-history.component.html',
  styleUrls: ['./fes-workflow-action-note-add-history.component.scss']
})
export class FesWorkflowActionNoteAddHistoryComponent extends WorkflowActionHistoryComponent implements OnInit {

  files: any[] = [];

  constructor(
    private messageService: MessageService,
    private fileService: FileServiceImpl
  ) {
    super();
  }

  payloadChanged(payload) {
    if (payload && payload.originalFileName && payload.id) {
      this.files = [{
        displayName: payload.originalFileName,
        id: payload.id
      }];
    }
  }

  ngOnInit() {
    super.ngOnInit();
  }

  onDownloadClicked(event: any) {
    this.fileService.downloadFile(
      event.id
    );
  }
}
